import { render, staticRenderFns } from "./CartButton.vue?vue&type=template&id=2aad43ec&"
import script from "./CartButton.vue?vue&type=script&lang=js&"
export * from "./CartButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports